// Libs
import { setReady } from '@/redux/reducers/socket'

// Constants
import { WS_EVENT_SYSTEM } from '@/constants/socketEvent'

// Types
import { IMessage } from '../handleMessageReceive'

const system = {
  action({ message, socket }: IMessage) {
    if (message?.ssid === WS_EVENT_SYSTEM.refresh) {
      return handleRefresh()
    } else if (message?.ssid === WS_EVENT_SYSTEM.ready) {
      return handleReady({ message, socket })
    }
  },
}

export default system

const handleRefresh = () => {
  window.location.reload()
}

const handleReady = ({ message, socket }: any) => {
  return setReady({ isReady: true, socket, userToken: message.body?.uid })
}
